import { Button } from '@skillarea/lib-frontend';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import styles from './Footer.module.css';

const CHAT_WITH_US_MAILTO = 'mailto:support@skillarea.online';

export function Footer() {
  const { t } = useTranslation('layout');

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Desktop Layout */}
        <div className={styles.desktopLayout}>
          <div className={styles.desktopHeader}>
            <Link to="/">
              <img
                alt={t('brand.logoAlt')}
                height={55}
                src="/logo.svg"
                width={196}
              />
            </Link>

            <nav className={styles.desktopNav}>
              <Link className={styles.navLink} to="/games">
                {t('nav.games')}
              </Link>
              <Link className={styles.navLink} to="/privacy">
                {t('nav.privacy')}
              </Link>
              <Link className={styles.navLink} to="/terms">
                {t('nav.terms')}
              </Link>
            </nav>
          </div>

          <div className={styles.desktopBottom}>
            <div className={styles.desktopInfo}>
              <div>
                <p className={styles.companyName}>{t('footer.companyName')}</p>
                <p className={styles.companyAddress}>
                  {t('footer.companyAddress')}
                </p>
              </div>

              <div className={styles.disclaimerBlock}>
                <div className={styles.redLine} />
                <p className={styles.disclaimer}>{t('footer.disclaimer')}</p>
              </div>
            </div>

            <div className={styles.contactBlock}>
              <a
                className={styles.emailLink}
                href="mailto:support@skillarea.online"
              >
                <img alt="" height={16} src="/icon-mail.svg" width={20} />
                <div className={styles.emailDivider} />
                <span>support@skillarea.online</span>
              </a>

              <Button
                as="a"
                className={styles.chatButton}
                color="accent"
                href={CHAT_WITH_US_MAILTO}
                variant="filled"
              >
                {t('footer.sendEmail')}
              </Button>
            </div>
          </div>
        </div>

        {/* Tablet Layout */}
        <div className={styles.tabletLayout}>
          <div className={styles.tabletHeader}>
            <div className={styles.tabletLeft}>
              <Link to="/">
                <img
                  alt={t('brand.logoAlt')}
                  height={55}
                  src="/logo.svg"
                  width={196}
                />
              </Link>

              <div className={styles.tabletContact}>
                <a
                  className={styles.tabletEmailLink}
                  href="mailto:support@skillarea.online"
                >
                  <img alt="" height={18} src="/icon-mail.svg" width={23} />
                  <div className={styles.tabletEmailDivider} />
                  <span>support@skillarea.online</span>
                </a>

                <Button
                  as="a"
                  className={styles.tabletChatButton}
                  color="accent"
                  href={CHAT_WITH_US_MAILTO}
                  variant="filled"
                >
                  {t('footer.sendEmail')}
                </Button>
              </div>
            </div>

            <nav className={styles.tabletNav}>
              <Link className={styles.tabletNavLink} to="/privacy">
                {t('nav.privacy')}
              </Link>
              <Link className={styles.tabletNavLink} to="/terms">
                {t('nav.terms')}
              </Link>
            </nav>
          </div>

          <div className={styles.tabletBottom}>
            <div className={styles.tabletCompany}>
              <p className={styles.tabletCompanyName}>
                {t('footer.companyName')}
              </p>
              <p className={styles.tabletCompanyAddress}>
                {t('footer.companyAddress')}
              </p>
            </div>

            <div className={styles.tabletRedLine} />

            <p className={styles.tabletDisclaimer}>{t('footer.disclaimer')}</p>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className={styles.mobileLayout}>
          <Link className={styles.mobileLogo} to="/">
            <img
              alt={t('brand.logoAlt')}
              className={styles.mobileLogoImage}
              src="/logo.svg"
            />
          </Link>

          <nav className={styles.mobileNav}>
            <Link className={styles.mobileNavLink} to="/games">
              {t('nav.games')}
            </Link>
            <Link className={styles.mobileNavLink} to="/privacy">
              {t('nav.privacy')}
            </Link>
            <Link className={styles.mobileNavLink} to="/terms">
              {t('nav.terms')}
            </Link>
          </nav>

          <div className={styles.mobileContact}>
            <a
              className={styles.mobileEmailLink}
              href="mailto:support@skillarea.online"
            >
              <img alt="" height={14} src="/icon-mail.svg" width={18} />
              <div className={styles.mobileEmailDivider} />
              <span>support@skillarea.online</span>
            </a>

            <Button
              as="a"
              className={styles.mobileChatButton}
              color="accent"
              href={CHAT_WITH_US_MAILTO}
              variant="filled"
            >
              {t('footer.sendEmail')}
            </Button>
          </div>

          <div className={styles.mobileCompany}>
            <p className={styles.mobileCompanyName}>
              {t('footer.companyName')}
            </p>
            <p className={styles.mobileCompanyAddress}>
              {t('footer.companyAddress')}
            </p>
          </div>

          <div className={styles.mobileDisclaimerBlock}>
            <div className={styles.mobileRedLine} />
            <p className={styles.mobileDisclaimer}>{t('footer.disclaimer')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
